import React from "react";
import { Box, Typography } from "@mui/material";
import { Check as CheckIcon } from "@mui/icons-material";
import { COLORS } from "../../styles/uiConstants";
import { useClinicTheme } from "../../theme";

const DOT = 22;

/**
 * DotStepper — nokta + çizgi adım göstergesi (drawer/sihirbaz üstünde).
 * Tamamlanan adım dolu nokta + tik, aktif adım halkalı nokta, bekleyen adım boş nokta.
 * Adımlar arasındaki çizgi, ulaşılan adıma kadar tema renginde dolar.
 *
 * @param {{ label: string }[]} steps
 * @param {number} activeStep - 0 tabanlı aktif adım
 */
export default function DotStepper({ steps, activeStep }) {
  const { palette } = useClinicTheme();
  const primary = palette.primary;

  return (
    <Box sx={{ display: "flex", alignItems: "flex-start", px: 1 }} role="list">
      {steps.map((step, i) => {
        const done = i < activeStep;
        const active = i === activeStep;
        const reached = i <= activeStep;
        return (
          <Box
            key={step.label}
            role="listitem"
            aria-current={active ? "step" : undefined}
            sx={{ flex: 1, position: "relative", display: "flex", flexDirection: "column", alignItems: "center", gap: 0.75 }}
          >
            {i > 0 && (
              <Box
                sx={{
                  position: "absolute",
                  top: DOT / 2 - 1,
                  left: "-50%",
                  width: "100%",
                  height: 2,
                  borderRadius: 1,
                  bgcolor: reached ? primary : COLORS.slate200,
                  transition: "background-color 0.25s",
                }}
              />
            )}
            <Box
              sx={{
                position: "relative",
                zIndex: 1,
                width: DOT,
                height: DOT,
                borderRadius: "50%",
                boxSizing: "border-box",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                bgcolor: done ? primary : COLORS.white,
                border: `2px solid ${reached ? primary : COLORS.slate300}`,
                color: palette.contrastText,
                transition: "all 0.25s",
              }}
            >
              {done ? (
                <CheckIcon sx={{ fontSize: 14 }} />
              ) : active ? (
                <Box sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: primary }} />
              ) : null}
            </Box>
            <Typography
              sx={{
                fontSize: 12,
                fontWeight: active ? 700 : 500,
                color: reached ? COLORS.slate800 : COLORS.slate400,
                textAlign: "center",
                lineHeight: 1.2,
              }}
            >
              {step.label}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}
